import useSWR, { mutate } from 'swr'

import { customerApiFetch } from '~/utils/api/customer-api'
import getCustomerApiEndpoints from '~/utils/api/get-customer-api-endpoints'

const gr4vyCheckoutSessionPath = (profileId: string) =>
  getCustomerApiEndpoints().gr4vyCheckoutSessionPath(profileId)

export const useGr4vyCheckoutSessionId = (profileId: string) =>
  useSWR(gr4vyCheckoutSessionPath(profileId), customerApiFetch)

export const reloadGr4vyCheckoutSessionId = (profileId: string) =>
  mutate(gr4vyCheckoutSessionPath(profileId))
